import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { clearStoreNewReports, getServicesFrecuency } from "../store/thunk";
import { FiAlertTriangle, FiSearch } from "react-icons/fi";
import { Table } from "../../../components/Table";
import { useEffect } from "react";


export const Frecuencia = () => {


    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const dispatch = useDispatch();
    // const { isLoading, servicesMaxMin, dateStart, dateEnd, msg } = useSelector(state => state.reports);
    const { isLoading, frecuency, dateStart, dateEnd, msg } = useSelector(state => state.newReports);
    const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });


    const searchData = (data) => {
        dispatch(getServicesFrecuency(data.fechaInicial, data.fechaFinal, data.opcion, data.extraer))
    }

    let serviciosData = [...frecuency];
    let columns = [
        {
            header: 'ID',
            dataIndex: 'SERVICIO_ID',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'SERVICIO',
            dataIndex: 'NOMBRE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'SOLICITADO',
            dataIndex: 'CONTEO',
            classHeader: 'text-end',
            classRow: 'text-end',
        },

    ];


    useEffect(() => {
        dispatch(clearStoreNewReports())
    }, [])

    return (
        <div className='row'>


            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div className='card'>
                    <div className='card-header border-bottom'>
                        <h4 className="h4 fw-bold">Frecuencia solicitud de servicios</h4>
                    </div>
                    <div className='card-body'>
                        <form className="row " onSubmit={handleSubmit(searchData)}>
                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                                {
                                    errors.fechaInicial &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                    </div>
                                }
                            </div>
                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal", { required: 'Introduce fecha final' })} />
                                {
                                    errors.fechaFinal &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaFinal.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 mb-2">
                                <label className="form-label">Extraer</label>
                                <input type="number" className="form-control" defaultValue={10} {...register("extraer", { required: 'Cantidad de registros a extraer' })} ></input>
                                {
                                    errors.extraer &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.extraer.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3 d-flex mt-3">
                                <div className="form-check">
                                    <input className="form-check-input" type="radio"  {...register("opcion")} value="1" defaultChecked />
                                    <label className="form-check-label" >
                                        Maxima frecuencia
                                    </label>
                                </div>
                                <div className="form-check ms-3 ">
                                    <input className="form-check-input" type="radio"  {...register("opcion")} value="2" />
                                    <label className="form-check-label" >
                                        Minima frecuencia
                                    </label>
                                </div>

                            </div>


                            <div className='col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2  mt-4'>
                                <button type="submit" className="btn btn-outline-dark ">  <FiSearch size={20} /> Buscar</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                <div className="card">
                    <div className="card-header border-bottom ">
                        <h5 className="card-title mb-0 text-black">Listado de Servicios</h5>
                    </div>
                    <div className="card-body">
                        <Table columns={columns} data={serviciosData} function_={[]} placeholderSearch="Buscar servicio"
                            showPagination={true} showControls={true} showTotals={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}
